// extracted by mini-css-extract-plugin
export default {"wrapper":"uy-z","button":"vy-z","alternate":"wy-z","disabled":"xy-z","paymentWarning":"yy-z","fadeIn":"zy-z"};